// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"SingleCard_cardContainer__3pSbH","cardTitle":"SingleCard_cardTitle__T7oWP","tiltContainer":"SingleCard_tiltContainer__306IQ"};